import React, { useEffect } from 'react';
import { MobileMenu } from './factory/Factory';
import styles from './NavigationMobile.module.scss';
import RoundedButton from '../../../atoms/roudedButton/RoundedButton';
import LanguageToggle from '../../../atoms/languageToggle/LanguageToggle';
import { useDispatch } from 'react-redux';
import { toggleAccessModal } from '../../../../app/globals/slice/sideModalSlice/SideModalSlice';
import { useNavigate } from 'react-router-dom';
import Text from '../../../atoms/text/Text';
const accessibilitySVG = '/assets/svg/header/Accessibility.svg';
const loginSvg = '/assets/svg/header/login.svg';
const academy360 = '/assets/svg/header/academy360.svg';
const govLogo = '/assets/svg/logo-svg/govtLogo-Colored.svg';

const NavigationMobile = ({ data, isRtl }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleAccessibility = (flag) => {
    dispatch(toggleAccessModal());
  };

  return (
    <>
      <nav className={isRtl ? `${styles.nav} rtl` : styles.nav}>
        <div className={styles.container}>
          <MobileMenu
            className={styles.menu}
            data={data}
            isRtl={isRtl}
            textClassName={styles['text-class']}
          />
        </div>
      </nav>

      <div className={styles['buttons-mobile']}>
        <div
          className={`${styles['nav-tools']} ${isRtl ? styles['navigation-rtl'] : ''}`}
        >
          <div
            className={styles['nav-item']}
            onClick={() => navigate('/coming-soon')}
          >
            <img src={academy360} loading="lazy" />
          </div>
          <div
            className={styles['nav-item']}
            onClick={() => handleAccessibility()}
          >
            <img src={accessibilitySVG} loading="lazy" />
          </div>
          <LanguageToggle
            className={styles['nav-item-en']}
            // titleClassname={styles['text-class']}
          />
          <div
            className={styles['nav-item']}
            onClick={() =>
              window.open(
                'https://dubaipolice.ac.ae/dpacademy/ar/std_login.jsp',
                '_blank'
              )
            }
          >
            <Text
              title="home.Sign_In"
              variant="text-regular-14"
              className={styles.signinText}
              color="#1a1a1a"
              svg={loginSvg}
            />
          </div>
        </div>

        <img
          src={govLogo}
          alt="dubai police Logo"
          onClick={() => window.open('https://www.dubai.ae/', '_blank')}
          className={styles['gov-logo']}
        />
      </div>
    </>
  );
};

export default NavigationMobile;
